import PropTypes from "prop-types";
import classNames from "classnames";

import { UNIT_STATUS, getUnitBattleVP } from "../../utils/battle-scoring";

const STATUS_OPTIONS = [
  { value: UNIT_STATUS.ACTIVE, label: "Active" },
  { value: UNIT_STATUS.QUARTER, label: "≤25%" },
  { value: UNIT_STATUS.FLEEING, label: "Fleeing" },
  { value: UNIT_STATUS.FLED, label: "Fled" },
  { value: UNIT_STATUS.DESTROYED, label: "Dead" },
];

export const UnitTracker = ({ unit, unitState, onStatusChange }) => {
  const status = unitState?.status || UNIT_STATUS.ACTIVE;
  const vp = getUnitBattleVP({ status, points: unit.points });

  return (
    <div
      className={classNames(
        "battle-unit",
        status !== UNIT_STATUS.ACTIVE && `battle-unit--${status}`,
      )}
    >
      <div className="battle-unit__header">
        <span className="battle-unit__name">
          {unit.strength > 1 && (
            <span className="battle-unit__strength">{unit.strength} </span>
          )}
          {unit.name}
          {unit.isGeneral && (
            <span className="battle-unit__tag">General</span>
          )}
          {unit.isBSB && <span className="battle-unit__tag">BSB</span>}
        </span>
        <span className="battle-unit__points">
          {vp > 0 ? <b>{vp} VP</b> : `${unit.points} pts`}
        </span>
      </div>
      <div className="battle-unit__statuses">
        {STATUS_OPTIONS.map(({ value, label }) => (
          <button
            key={value}
            type="button"
            className={classNames(
              "battle-unit__status",
              `battle-unit__status--${value}`,
              status === value && "battle-unit__status--selected",
            )}
            onClick={() =>
              onStatusChange(
                // Tapping the current status resets to active.
                status === value && value !== UNIT_STATUS.ACTIVE
                  ? UNIT_STATUS.ACTIVE
                  : value,
              )
            }
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

UnitTracker.propTypes = {
  unit: PropTypes.object.isRequired,
  unitState: PropTypes.object,
  onStatusChange: PropTypes.func.isRequired,
};
